import ISessionContextState from '@/types/ISessionContextState';
import React from 'react';

export default React.createContext<ISessionContextState | undefined>(undefined);
